var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small"},[_c('pie-chart',{staticStyle:{"padding":"7px"},attrs:{"height":300,"chart-data":_vm.CHARTDATA}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }